import React from 'react'
import { Box, Button, Flex, Text, useColorModeValue } from '@chakra-ui/react'

interface IProps {
  title?: string
  description?: string,
  ctaText?: string
  onClick?: () => void
}

const EmptyState: React.FC<IProps> = ({ title, description, ctaText, onClick }) => {
  return (
    <Flex color={useColorModeValue('blackAlpha.500', 'whiteAlpha.500')} align={'center'} justifyContent="center" direction="column" p={20} pt={200}>
      <Box width={200} height={200} borderRadius={200} backgroundColor={useColorModeValue('gray.200', 'gray.700')} />
      {title ? <Text mt={4} fontSize="3xl">{ title }</Text> : null }
      {description ? <Text mt={3}>{ description }</Text> : null }
    { ctaText ? <Button colorScheme={'purple'} mt={3} onClick={onClick}>{ ctaText }</Button> : null }
    </Flex>
  )
}

export default EmptyState
